// extracted by mini-css-extract-plugin
module.exports = {"card":"YelpCard--card--3JfrL","profile":"YelpCard--profile--3Zv4C","userInfo":"YelpCard--userInfo--22h_5","rating":"YelpCard--rating--3qUag","avatar":"YelpCard--avatar--1MXv_"};